// extracted by mini-css-extract-plugin
module.exports = {"card":"MyUnsubscribeFormCard_card__s3s_3","rotation":"MyUnsubscribeFormCard_rotation__6xYr_"};